import React from 'react';

const SidebarTabButton = ({setSelectedTab,text,tab,selectedTab,colSize,disabled}) => (
	<a href="javascript:void(0)" onClick={() => setSelectedTab(tab)} className={`${tab==selectedTab ? 'current':''} ${colSize?colSize:'col-sm-4'} ${disabled === true ? 'disabled':''} btn btn-outline btn-default`}>{text}</a>
);

export default SidebarTabButton;


// WEBPACK FOOTER //
// ./components/builder/SidebarTabButton.js